export const environment = {
      production: true,
      SEGMENT_WRITE_KEY: "OI0Vv8TUJ6RRt5RoPlI8ppNEmQxcuDCZ",
      CRDS_GQL_ENDPOINT: "https://api-int.crossroads.net/graphql-gateway",
      CRDS_ENV: "int",
  };
  